export const create = {
  createSuccessfully: '新しいタンクを正常に作成しました！',
  createFailed: '新しいタンクの作成に失敗しました！',
}
